import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { crmRestrictionsStore } from '../../store';
import { SCREENS } from 'src/constants/screens';
import { localeStore } from 'src/mobx/localesStore';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import Headers from 'src/view/containers/Headers/Headers';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import { BUTTON_TITLE } from '~/constants/main';
import './style.scss';
import Text, { TEXT } from '~/view/components/Text/Text';
import CustomLazyPicker from '~/view/components/Controls/Pickers/CustomLazyPicker/CustomLazyPicker';
import { Checkbox } from '~/view/components/Controls/Checkbox/Checkbox';
import { history } from '~/services/history';
import { paymentTypes } from '~/view/screens/CrmScreen/screens/CrmRestrictionsScreen/constants';

const CrmRestrictionsEdit: React.FC = observer((): JSX.Element => {
  const { customer: customerValidation } = crmRestrictionsStore.validationErrors;

  useEffect(() => {
    return () => crmRestrictionsStore.clearEditing();
  }, []);

  const handleSave = async () => {
    crmRestrictionsStore.validate();

    const isValidForm = Object.values(crmRestrictionsStore.validationErrors).every((field) => field.isValid);
    if (!isValidForm) return;

    await crmRestrictionsStore.createRestriction();

    history.push(SCREENS.CRM_RESTRICTIONS());
  };

  return (
    <div className="d-flex flex-column full-width crm-restrictions-create">
      <Headers>
        <HeaderBack title={'crm_restrictions_create'} path={SCREENS.CRM_RESTRICTIONS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <div className="crm-restrictions-create__input-wrapper">
          <Text type={TEXT.CUSTOM} text="crm_restrictions_mobile_col" className="crm-restrictions-create__input-label" required />
          <CustomLazyPicker
            className="mr-2"
            inputClassName={`report-header__picker ${customerValidation.isValid ? '' : 'input-error'}`}
            onFetch={crmRestrictionsStore.fetchCustomers}
            selectedOptions={crmRestrictionsStore.restriction.customer}
            onSelect={(value) => crmRestrictionsStore.changeRestrictionHandler({ customer: value })}
            isSearchable
            optionsDesc="customers"
          />
          {!customerValidation.isValid && customerValidation.errorText ? (
            <div className="input-error-message ml-3">{customerValidation.errorText}</div>
          ) : null}
        </div>
        <div className="crm-restrictions-create__input-wrapper">
          <Text type={TEXT.CUSTOM} text="crm_restrictions_payment_type_col" className="crm-restrictions-create__input-label" required />
          {Object.entries(paymentTypes).map(([key, value]) => (
            <Checkbox
              key={`payment_type_${key}`}
              type="radio"
              className="mb-2"
              value={crmRestrictionsStore.restriction.payment_type === Number(key)}
              label={value}
              name={key}
              onClick={(value) => crmRestrictionsStore.changeRestrictionHandler({ payment_type: Number(value) })}
            />
          ))}
        </div>
        <div className="crm-restrictions-create__input-wrapper">
          <Text type={TEXT.CUSTOM} text="crm_restrictions_comments_col" className="crm-restrictions-create__input-label" />
          <textarea
            value={crmRestrictionsStore.restriction.comment}
            onChange={(e) => crmRestrictionsStore.changeRestrictionHandler({ comment: e.target.value })}
            maxLength={500}
            className={`refund-reason-message__text-area letter-spacing-5`}
          />
        </div>
        <div className="d-flex align-items-center mt-3 gap-10">
          <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={handleSave} />
        </div>
      </div>
    </div>
  );
});

export default CrmRestrictionsEdit;
